import { CreditOperationAndSocialSecurityCardsConfiaPage } from './ConfiaPage';
import { CreditOperationAndSocialSecurityCardsSignedPage } from './SignedPage';
import { CreditOperationAndSocialSecurityCardsEnrichPersonalData } from './EnrichPersonalData';
import { CreditOperationAndSocialSecurityCardsLogin } from './Login';
import { CreditOperationAndSocialSecurityCardsResumeOperation } from './ResumeOperation';
import { CreditOperationAndSocialSecurityCardsSocialSecurityCards } from './SocialSecurityCards';
import { CreditOperationAndSocialSecurityCardsPersonalDocument } from './PersonalDocument';

export const CreditOperationAndSocialSecurityCardsTheme = {

    ConfiaPage: CreditOperationAndSocialSecurityCardsConfiaPage,
    SignedPage: CreditOperationAndSocialSecurityCardsSignedPage,
    EnrichPersonalData: CreditOperationAndSocialSecurityCardsEnrichPersonalData,
    Login: CreditOperationAndSocialSecurityCardsLogin,
    ResumeOperation: CreditOperationAndSocialSecurityCardsResumeOperation,
    SocialSecurityCards: CreditOperationAndSocialSecurityCardsSocialSecurityCards,
    PersonalDocument: CreditOperationAndSocialSecurityCardsPersonalDocument,
} as const;